module.exports = {
    getValue: function (target, fieldName) {
        var value = undefined;
        if (angular.isDefined(target) && angular.isDefined(fieldName)) {
            value = target[fieldName];
        }
        return value;
    },

    getListOfProperties: function (list, elementName) {
        var elements = [];
        angular.forEach(list, function (item) {
            var value = item[elementName];
            if (angular.isDefined(value)) {
                elements.push(value);
            }
        });

        return elements;
    },

    getUniqueListOfProperties: function (list, elementName) {
        return new Set(getListOfProperties(list, elementName));
    },

    getIndex: function (collection, fieldName, neededValue) {
        var index = -1;
        var count = 0;
        angular.forEach(collection, function (object) {
            if (object[fieldName] == neededValue) {
                index = count;
            } else {
                count++;
            }
        });
        return index;
    },

    getIndexTimestamp: function (collection, neededValue) {
        var index = -1;
        var count = 0;
        angular.forEach(collection, function (object) {
            if (object.timestamp.getTime() == neededValue.getTime()) {
                index = count;
            } else {
                count++;
            }
        });
        return index;
    },

    extractProperty: function (propertyName, target) {
        var value = {};
        var newFieldName = '';
        var parts = propertyName.split('.');
        if (parts.length == 1) {
            //not nested
            value.object = target[propertyName];
            value.title = parts[0];
        } else {
            //nested
            var subObject = target;
            for (var nestedCounter = 0; nestedCounter < parts.length; nestedCounter++) {
                if (angular.isDefined(subObject)) {
                    var fieldNamePart = parts[nestedCounter];
                    var subsub = subObject[fieldNamePart];
                    subObject = subsub;
                    newFieldName = newFieldName + fieldNamePart;
                } else {
                    break;
                }
            }
            value.object = subObject;
            value.title = newFieldName;
        }
        return value;
    },

    isDefined: function (object) {
        return object != null && typeof object !== 'undefined';
    },

    isEmpty: function (object) {
        return this.isDefined(object) ? (Object.keys(object).length === 0) : false;
    },

    isTrue: function (object) {
        return module.exports.isDefined(object) && object === true;
    },

    copyProperties: function copyProperties(from, to) {
        for (var property in from) {
            if (from.hasOwnProperty(property)) {
                to[property] = from[property];
            }
        }
        return to;
    },

    isChecked: function isChecked(property) {
        var checked = false;
        if (angular.isDefined(property) && angular.isDefined(property.checked)) {
            checked = property.checked;
        }
        return checked;
    },

    isNotChecked: function (property) {
        return !module.exports.isChecked(property);
    },


    containsText: function (object, text) {
        return object.toLowerCase().indexOf(text.toLowerCase()) !== -1;
    },


    isFunction: function (functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    },

    /**
     * Accepts array that holds multiple values for the the specified key ( slas per train, slas per date etc )
     * Returns Map that holds those multiple values per key.
     * @param array
     * @param keyProperty name of property that acts as the key.
     * @param shouldBeMappedFn Fn that returns boolean wether value should be put in the map or not.
     */
    mapKeyValues: function (array, keyProperty, shouldBeMappedFn) {
        var map = new Map();
        array.forEach(function (o) {
            var key = o[keyProperty];

            if (module.exports.isDefined(shouldBeMappedFn)) {
                if (!shouldBeMappedFn(key)) {
                    return;
                }
            }

            var mapped = map.get(key);
            if (!module.exports.isDefined(mapped)) {
                mapped = [];
                map.set(key, mapped);
            }
            mapped.push(o);
        });
        return map;
    },

    /**
     * add property 'checked' to the union on both lists.
     *
     * @param allValues
     * @param wantedValues
     * @param fieldNameAll name of property to use to compare equalness.
     * @param fieldNameWanted name of property to use to compare equalness.
     */
    checkWantedValues: function (allValues, wantedValues, fieldNameAll, fieldNameWanted) {

        if (module.exports.isDefined(wantedValues)) {
            allValues.forEach(function (value) {
                if (wantedValues.length !== 0) {
                    // for every trainMaintainer String, look in the selected maintainers list if it has a matching record.
                    wantedValues.some(function (wantedValue) {
                        // should be done by reference: that's why we do it in such a stupid way :/
                        if (value[fieldNameAll] === wantedValue[fieldNameWanted]) {
                            value.checked = wantedValue.checked;
                            return true;
                        }
                        else {
                            value.checked = false;
                            return false;
                        }
                    });
                }
                else {
                    value.checked = false;
                }
            });
        }
    }

};

